import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';

import Burger from 'components/atoms/Burger';
import MobileMenu from 'components/molecules/MobileMenu';

import LogoSvg from 'assets/images/ristora-logo.svg';

import { Wrapper, Image } from './styled';
import RouterHelper from '../../../services/RouterHelper';
import routeCodes from '../../../common/constants/route-codes';
import { useMenuStep } from '../../../hooks/use-menu-step';

const AdminHeader = () => {
  const [openMenu, setMenuOpen] = useState(false);
  const { updateMenuStep } = useMenuStep();

  const onChange = useCallback(() => {
    setMenuOpen((bool) => !bool);
  }, []);

  const closeMenu = useCallback(() => {
    setMenuOpen(false);
  }, []);

  return (
    <Wrapper>
      <Link
        to={RouterHelper.getRedirectRouteWithRestaurantId(routeCodes.home)}
        style={{ marginTop: 5 }}
      >
        <Image src={LogoSvg} />
      </Link>
      <Burger onChange={onChange} open={openMenu} />
      <MobileMenu
        open={openMenu}
        updateMenuStep={updateMenuStep}
        onClose={closeMenu}
      />
    </Wrapper>
  );
};

export default AdminHeader;
